import { render } from "./TrendingView.vue?vue&type=template&id=5d6471c7"
const script = {}
script.render = render

export default script